import { useMutation, useSuspenseQuery } from '@tanstack/react-query';

import PrivacyAgreeService from 'legacy/api/PrivacyAgreeService';

export const useSuspenseData = (params) => {
  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['suspensePersonalInfo'],
    queryFn: () => PrivacyAgreeService.myMenuCcrcThrd(params),
    retry: 1,
  });
  return data;
};

export const useSendCcrcInfo = () => {
  return useMutation({
    mutationKey: ['sendPersonalInfo'],
    mutationFn: (params) => PrivacyAgreeService.myMenuCcrcThrdRslt(params),
  });
};
